<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1716 14.1455L14.9998 3.5999C14.9998 2.9369 14.4628 2.3999 13.7998 2.3999H8.9998H4.1998C3.5368 2.3999 2.9998 2.9369 2.9998 3.5999L1.828 14.1455C1.8106 14.2277 1.7998 14.3123 1.7998 14.3999C1.7998 15.0629 2.3368 15.5999 2.9998 15.5999H8.9998H14.9998C15.6628 15.5999 16.1998 15.0629 16.1998 14.3999C16.1998 14.3123 16.189 14.2277 16.1716 14.1455ZM11.9998 5.3447V5.9999C11.9998 7.6541 10.654 8.9999 8.9998 8.9999C7.3456 8.9999 5.9998 7.6541 5.9998 5.9999V5.3447C5.6512 5.2211 5.3998 4.8911 5.3998 4.4999C5.3998 4.0031 5.803 3.5999 6.2998 3.5999C6.7966 3.5999 7.1998 4.0031 7.1998 4.4999V5.9999C7.1998 6.9923 8.0074 7.7999 8.9998 7.7999C9.9922 7.7999 10.7998 6.9923 10.7998 5.9999V4.4999C10.7998 4.0031 11.203 3.5999 11.6998 3.5999C12.1966 3.5999 12.5998 4.0031 12.5998 4.4999C12.5998 4.8911 12.3484 5.2211 11.9998 5.3447Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGAdminProducts"
    }
</script>

<style scoped>

</style>
